export const checkAchieveUnlockedFeatures = (dataName, unlockedFeatures, bankSavingsActive, retirementSavingsActive,
        creditCardActive, investmentActive) => {
    let featureUnlocked = false;
    let unlockedFeature = false;
    let featureName = "";
    let featureDisplayName = "";
    let featureActive = false;
    let level = 1;
    switch (dataName){
        case "bankSavings":
            featureName = "moneyBuilder";
            featureDisplayName = "bank savings feature of money builder";
            featureActive = bankSavingsActive;
            break;
        case "creditCardBalance":
            featureName = "creditCard";
            featureDisplayName = "credit card";
            featureActive = creditCardActive;
            break;
        case "retirementSavings":
            featureName = "moneyBuilder";
            featureDisplayName = "retirement savings feature of money builder";
            level = 2;
            featureActive = retirementSavingsActive;
            break;
        case "investmentMix":
        case "investments":
            featureName = "moneyBuilder";
            featureDisplayName = "investments feature of money builder";
            level = 3;
            featureActive = investmentActive;
            break;
        default:
            break;
    }
    if (featureName !== ""){
        unlockedFeature = true;
        const unlockedFeatureObj = unlockedFeatures.find(elem => elem.featureName === featureName);
        if (unlockedFeatureObj && unlockedFeatureObj.level >= level){
                featureUnlocked = true;
        }
    }else{
        featureUnlocked = "N/A";
    }
    const returnObj = {featureName: featureName, featureDisplayName: featureDisplayName, 
        featureUnlocked: featureUnlocked, unlockedFeatureFound: unlockedFeature, 
        featureActive: featureActive};
    return returnObj;
}
export default checkAchieveUnlockedFeatures;